<template>
  <div class="home-page">
    <div class="vx-row">
      <div class="loader-block loader-block2" v-if="axiosInstance">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">SEARCH</h2>
        <vx-card>
            <div class="d-flex w-100 justify-center">
                <vx-input-group class="custom-input-group concepts-search w-100">
                    <div class="d-flex">
                        <div class="relative flex-grow">
                            <vs-input loading v-model="searchQuery"
                                      style="width: 100%"
                                      placeholder="Type at least 3 characters."
                                      class="has-icons"
                                      @keypress.enter="restartSearch"
                            />
                            <div class="icons">
                                <feather-icon v-if="searchQuery" icon="XIcon"
                                              svgClasses="h-6 w-6 cursor-pointer"
                                              @click="clearSearch"
                                              style="opacity: 0.7; margin-right: 5px;"/>
                                <div v-if="axiosInstance" class="vs-input__loading"
                                     style="margin-left: 5px;"/>
                                <feather-icon
                                    v-else
                                    @click="restartSearch"
                                    style="margin-right: 5px; cursor: pointer"
                                    icon="SearchIcon" svgClasses="h-6 w-6" :class="{'active-search-btn': axiosInstance}"/>
                            </div>
                        </div>
                    </div>
                </vx-input-group>
            </div>
        </vx-card>
      <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6" v-for="(item, index) in items" :key="index">
          <AssetItem :item="item" :show-images="showImages" />
      </div>
        <div class="loader-block scroll-loader" v-if="axiosInstance && items.length">
            <div class="loading">
                <div class="effect-1 effects"></div>
                <div class="effect-2 effects"></div>
                <div class="effect-3 effects"></div>
            </div>
        </div>
<!--      <div class="pagination-block">-->
<!--        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"-->
<!--                       @change="handlePaginationChange"></vs-pagination>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import AssetItem from "../components/AssetItem";
    export default {
        name: 'Home',
        components: {AssetItem},
        head() {
            return {
                title: {
                    inner: 'AMP',
                    separator: ' ',
                    complement: ''
                },
                meta: [
                    {hid: 'description', name: 'description', content: ''}
                ]
            }
        },
        data() {
            return {
                axiosInstance: false,
                orderBy: {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                },
                searchQuery: '',
                items: [],
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 24,
                totalPages: 0,
                showImages: false,
            }
        },
        computed: {},
        mounted() {
            // this.search();
            let el = document.documentElement;
            window.addEventListener("scroll", (e) => {
                if (el.scrollTop + el.offsetHeight >= el.scrollHeight-100 && !this.axiosInstance) {
                    this.currentPage++;
                    this.search();
                }
            })
        },

        beforeDestroy(){
            this.$root.$off('update_search');
            this.$root.$off('clearSearch');
        },
        methods: {
            getOrderByName() {
                if (this.orderBy) {
                    if (this.orderBy.order_by === 'updatedAt') {
                        if (this.orderBy.order === 'asc') {
                            return 'Oldest'
                        } else {
                            return 'Newest'
                        }
                    } else {
                        if (this.orderBy.order === 'asc') {
                            return 'A-Z'
                        } else {
                            return 'Z-A'
                        }
                    }
                } else {
                    return 'Relevance';
                }
            },
            onScroll() {

            },
            changeOrderBy(field, order, without_search) {
                if (field && order) {
                    this.orderBy = {
                        order_by: field,
                        order: order
                    };
                } else {
                    this.orderBy = null;
                }

                this.updateUrl();

                if (!without_search) {
                    setTimeout(() => {
                        this.search()
                    }, 10)
                }
            },
            handlePaginationChange() {
                if (this.isMounted) {
                    this.items = [];
                    this.search();
                }
            },
            clearSearch() {
              this.searchQuery = "";
              this.items = [];
            },
            restartSearch() {
                this.items = [];
                this.search();
            },
            search() {
                this.mediaItems = [];
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();

                let url = `https://staging1ms.embibe.com/fs_ms/ampsearch`;
                let qObj = {
                    user_id: 123,
                    size: this.itemsPerPage,
                    start: (this.currentPage - 1) * this.itemsPerPage
                };
                if (this.searchQuery) {
                    qObj.query = this.searchQuery;
                }
                if (this.orderBy) {
                    qObj._sort = `${this.orderBy.order_by}:${this.orderBy.order}`
                }

                let types = [];
                for (let k in this.$store.state.typeFilters) {
                    if (this.$store.state.typeFilters[k]) {
                        types.push(k)
                    }
                }
                if (types.length > 0) {
                    qObj.asset_types = JSON.stringify(types);
                }
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                url += q;
                if (this.axiosInstance) {
                    this.axiosInstance.cancel();
                }
                this.showImages = false;
                this.axiosInstance = source;

                this.$axios.get(url, {cancelToken: source.token}).then(res => {
                    this.items.push(...res.data.content.map(a => Object.assign(a, {_id: a.asset_object_id})));
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)

                        if (!this.isMounted) {
                            setTimeout(() => {
                                this.isMounted = true;
                            }, 200)
                        }
                }).catch(e => {
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    console.log('catch_search', e)
                });
            },
            changePerPage(limit) {
                this.itemsPerPage = limit;
                setTimeout(() => {
                    this.search()
                }, 10)
            }
        },
        watch: {
            axiosInstance: function() {
                if (this.axiosInstance === false) {
                    this.$root.$emit('search_loading', false);
                }
            },
        },
    }
</script>
<style>
    .scroll-loader {
        position: relative;
        height: 50px;
    }
</style>
